import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { compose } from 'redux';

import { reloadBoard } from 'common/actions/boards';
import { reloadIdeaPost } from 'common/actions/ideaPost';
import { invalidatePostQueries } from 'common/actions/postQueries';
import { reloadPost, reloadPostByURLName } from 'common/actions/posts';
import { reloadPostActivity } from 'common/actions/postsActivity';
import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { LocationContext, RouterContext } from 'common/containers/RouterContainer';
import { ShowToastContext, ToastTypes } from 'common/containers/ToastContainer';
import ControlledDropdown from 'common/ControlledDropdown';
import connect from 'common/core/connect';
import parseAPIResponse from 'common/util/parseAPIResponse';
import stringSort from 'common/util/stringSort';
import withContexts from 'common/util/withContexts';

import 'css/components/post/_MovePostDropdown.scss';

class MovePostDropdown extends Component {
  static propTypes = {
    board: PropTypes.object,
    boards: PropTypes.array,
    company: PropTypes.object,
    location: PropTypes.object,
    onPostMoved: PropTypes.func,
    post: PropTypes.object,
    router: PropTypes.object,
    showToast: PropTypes.func,
  };

  state = {
    board: this.props.board,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.board !== this.props.board) {
      this.setState({ board: this.props.board });
    }
  }

  replaceBoardInURL = (board) => {
    const { router } = this.props;
    const {
      location: { pathname, search },
    } = router;

    /**
     * TODO:
     * - Add Roadmap case, add other cases (e.g Autopilot)
     */
    const splitPathname = pathname.split('/');
    const [, , subRouteSegment] = splitPathname;
    if (subRouteSegment === 'feedback') {
      const [, , , , ...rest] = splitPathname;
      const restOfPath = rest.join('/');
      const newPath = `/admin/feedback/${board.urlName}/${restOfPath}${search}`;
      router.replace(newPath);
    } else if (subRouteSegment === 'roadmap') {
      // Admin Roadmap page
    } else {
      // Check other cases (e.g Autopilot)
    }
  };

  onMovePost = async (intoBoardID) => {
    const { boards, post, showToast } = this.props;
    const { board: currentBoard } = this.state;

    if (post.boardID === intoBoardID) {
      return;
    }

    const intoBoard = boards.find((board) => board._id === intoBoardID);
    if (!intoBoard) {
      return;
    }

    const previousBoard = currentBoard;
    this.setState({ board: intoBoard });

    const response = await AJAX.post('/api/posts/move', {
      boardID: intoBoardID,
      postID: post._id,
    });

    const { error, parsedResponse } = parseAPIResponse(response, {
      isSuccessful: (parsedResponse) => parsedResponse.urlName && parsedResponse.success,
    });

    if (error || !parsedResponse) {
      this.setState({ board: previousBoard });
      showToast(error?.message || 'Something went wrong. Please try again.', ToastTypes.error);
      return;
    }

    const { board, onPostMoved } = this.props;
    const fromBoard = board;

    await onPostMoved(post, fromBoard, intoBoard, parsedResponse.urlName);

    this.replaceBoardInURL(intoBoard);
    showToast(`This post has been moved to "${intoBoard.name}"`);
  };

  renderDropdown() {
    const { boards } = this.props;
    const { board: currentBoard } = this.state;

    const options = boards.sort(stringSort('name')).map((board) => {
      return {
        name: board._id,
        render: board.name,
      };
    });
    return (
      <ControlledDropdown
        dropdownClassName="movePostDropdownPortal"
        minWidth={165}
        onChange={this.onMovePost}
        options={options}
        selectedName={currentBoard._id}
      />
    );
  }

  render() {
    return (
      <div className="movePostDropdown">
        <div className="searchContainer">{this.renderDropdown()}</div>
      </div>
    );
  }
}

/**
 * @deprecated Use PostBoardSelect instead
 */
export default compose(
  connect(null, (dispatch) => ({
    onPostMoved: (post, fromBoard, intoBoard, intoURLName) => {
      return Promise.all([
        dispatch(invalidatePostQueries()),
        dispatch(reloadBoard(fromBoard.urlName)),
        dispatch(reloadBoard(intoBoard.urlName)),
        dispatch(reloadPost(post)),
        dispatch(reloadPostActivity(post)),
        dispatch(reloadPostByURLName(intoBoard, intoURLName)),
        post.ideaID ? dispatch(reloadIdeaPost({ ideaID: post.ideaID })) : Promise.resolve(),
      ]);
    },
  })),
  withContexts(
    {
      company: CompanyContext,
      location: LocationContext,
      router: RouterContext,
      showToast: ShowToastContext,
    },
    {
      forwardRef: true,
    },
  ),
)(MovePostDropdown);
